import React, { FC, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';

import { MultiSelectDropdown } from '../../_common/MultiSelectDropdown/MultiSelectDropdown';
import { GET_ALL_REGIONS, GET_ALL_DRIVERS_BY_REGION_IDS } from '../../../graphql/client/queries';
import {
    GetAllRegions,
    GetAllRegions_getAllRegions as RegionType,
    GetAllDriversByRegionIds,
    GetAllDriversByRegionIds_getAllDriversByRegionIds as DriverByRegionType,
} from '../../../types/schemaTypes';
// import { ValueType } from 'react-select/src/types';
import { Routes } from '../../../utils';
import { SEND_MESSAGE_TO_CONVERSATION } from '../../../graphql/client/mutations';
import moment from 'moment';
import { useStoreContext } from '../../App/StoreProvider';
import MessageFilters from '../MessageFilters';
import { Loading } from '../../_common';
import { useNavigation } from 'react-router';

interface Option {
    id: number | string;
    name: string | number;
}

interface OptionType {
    label: string;
    value: string;
}

interface LooseObject {
    [key: string]: any;
}

const MessagesCreate: FC = (): React.ReactElement => {
    const [conversationName, setConversationName] = useState<string>('');
    const [selectedRegionIds, setSelectedRegionIds] = useState<number[]>([]);
    const [selectedRecipientIds, setSelectedRecipientIds] = useState<number[]>([]);
    const [selectedRecipients, setSelectedRecipients] = useState<OptionType | null | undefined>(null);
    const [sendAllRecipientCheckboxState, setSendAllRecipientCheckboxState] = useState<boolean>(false);
    const [disabledButton, setDisabledButton] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const { data: regionsData } = useQuery<GetAllRegions>(GET_ALL_REGIONS);
    const history :any = useNavigation();

    const [{ auth }] = useStoreContext();

    const regions: OptionType[] = [];

    if (regionsData?.getAllRegions) {
        regionsData.getAllRegions.forEach((element: RegionType | null) => {
            if (element?.regionName != null && element?.id != null) {
                regions.push({
                    value: String(element.id),
                    label: element.regionName,
                });
            }
        });
    }

    const drivers: OptionType[] = [];

    const { data: driversData } = useQuery<GetAllDriversByRegionIds>(GET_ALL_DRIVERS_BY_REGION_IDS, {
        variables: { ids: selectedRegionIds },
        fetchPolicy: 'network-only',
    });

    const messageCreateVariable = {
        conversationName: conversationName,
        driverIdList: selectedRecipientIds,
        isFromDriver: false,
        isGrupal: true,
        message: {
            conversationName: conversationName,
            creationDate: moment.utc().format(),
            bodyMessage: 'Group Created',
            messageType: 'Regular',
        },
        regionIdList: selectedRegionIds,
        userId: parseInt(auth.user.profile.id),
    };

    if (driversData?.getAllDriversByRegionIds) {
        driversData.getAllDriversByRegionIds.forEach((element: DriverByRegionType | null) => {
            if (element?.name != null && element?.id != null) {
                drivers.push({
                    value: String(element.id),
                    label: element.name,
                });
            }
        });
    }

    const onRegionChange = (selectedRegion: OptionType): void => {
        setSendAllRecipientCheckboxState(false);
        setSelectedRecipientIds([]);
        const selectedRegionIds: number[] = [];
        if (selectedRegion && selectedRegion !== null && Array.isArray(selectedRegion)) {
            for (let i = 0; i < selectedRegion.length; i++) {
                selectedRegionIds.push(parseInt(selectedRegion[i].value));
            }
        }
        setSelectedRegionIds(selectedRegionIds);
    };

    const onRecipientChange = (selectedRecipient: OptionType): void => {
        
        // setSelectedRecipients(selectedRecipient);
        setSendAllRecipientCheckboxState(false);
        const selectedRecipientIds: number[] = [];
        if (selectedRecipient && selectedRecipient !== null && Array.isArray(selectedRecipient)) {
            for (let i = 0; i < selectedRecipient.length; i++) {
                selectedRecipientIds.push(parseInt(selectedRecipient[i].value));
            }
        }
        setSelectedRecipientIds(selectedRecipientIds);
    };

    const sendToAllCheckboxHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setSendAllRecipientCheckboxState(true);
            setSelectedRecipients(null );
            const allDriverIds: number[] = drivers.map(driver => parseInt(driver.value));
            setSelectedRecipientIds(Array.from(new Set(allDriverIds)));
        } else {
            setSendAllRecipientCheckboxState(false);
        }
    };

    const [sendMessageToConversation, { loading: mutationLoading }] = useMutation<LooseObject>(
        SEND_MESSAGE_TO_CONVERSATION,
        {
            onCompleted: data => {
                localStorage.setItem(
                    'driverData_' + data.sendMessageToConversation.conversationId,
                    JSON.stringify({
                        isGroupAl: true,
                        cellPhone: 'Group Message',
                        name: data.sendMessageToConversation.conversationName,
                        markAllRead: true,
                        driver: data.sendMessageToConversation,
                    }),
                );
                history(`${Routes.MESSAGES.route}${data.sendMessageToConversation.conversationId}`);
            },

            onError: (e) => {
                if (CombinedGraphQLErrors.is(e)) {
                    console.log('GraphQL Error', e.errors);
                } else {
                    console.log('Error', e.message);
                }
            },
        },
    );

    const sendMessageToConversationHandler = async () => {
        setDisabledButton(true);
        await sendMessageToConversation({
            variables: { input: messageCreateVariable },
        });
        setDisabledButton(false);
    };

    return (
        <div className="Messages-Container">
            <div className="Messages-BodyContainer">
                <MessageFilters
                    history={history}
                    showFilter={showFilter}
                    showFilterHandler={() => setShowFilter(prevShowFilter => !prevShowFilter)}
                />
                <div id="MessagesCreateNewContainer" className="MessagesCreateNew-Container">
                    <div className="Messages-LoadList" id="loadList">
                        <div className="Messages-Header">
                            <div className="row ml-2">
                                <div className="col-sm-12 my-auto pl-0">
                                    <div className="title">New Message</div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 pl-0">
                                {mutationLoading ? (
                                    <Loading />
                                ) : (
                                    <div className="Message-Container">
                                        <div className="pb-2">
                                            <label>Create Conversation</label>
                                            <div className="SearchBar-Container">
                                                <input
                                                    type="text"
                                                    placeholder="Name your Conversation..."
                                                    className="SearchBar-Input"
                                                    value={conversationName}
                                                    onChange={event => setConversationName(event.target.value)}
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                        <div className="pb-2">
                                            <MultiSelectDropdown
                                                dropdownOptions={regions}
                                                label="Select Region(s)..."
                                                onChange={(value: OptionType): void => {
                                                    onRegionChange(value);
                                                }}
                                            />
                                            <div className="FilterCheckBox-Container row mt-3 ml-4">
                                                <input
                                                    type="checkbox"
                                                    className="FilterCheckBox-Checkbox"
                                                    checked={sendAllRecipientCheckboxState}
                                                    // value={sendAllRecipientCheckboxState}
                                                    onChange={sendToAllCheckboxHandler}
                                                />
                                                <span className="FilterCheckBox-Title">
                                                    Send To <strong>ALL</strong> Recipients in Region
                                                </span>
                                            </div>
                                        </div>
                                        <div className="pb-2">
                                            <MultiSelectDropdown
                                                disabled={sendAllRecipientCheckboxState}
                                                dropdownOptions={drivers}
                                                label="Select Recipient(s)..."
                                                onChange={(value: OptionType): void => {
                                                    onRecipientChange(value);
                                                    setSelectedRecipients(value);
                                                }}
                                                value={selectedRecipients}
                                            />
                                        </div>
                                        <div className="pb-2 text-right">
                                            <a href={Routes.MESSAGES.route} className="cancel">
                                                Cancel
                                            </a>
                                            <button
                                                className="start"
                                                onClick={sendMessageToConversationHandler}
                                                disabled={disabledButton}
                                            >
                                                Start
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MessagesCreate;

